var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalSearchNoResults(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.3 86",
    style: {
      enableBackground: "new 0 0 90.3 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D5DEE8;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st0",
    d: "M12.2,0h65.9c5.5,0,10,4.5,10,10V76c0,5.5-4.5,10-10,10H12.2c-5.5,0-10-4.5-10-10V10 C2.2,4.5,6.7,0,12.2,0C12.2,0,12.2,0,12.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7083",
    className: "st1",
    d: "M69.5,61.3c0.9,0.9,0.9,2.4,0,3.3l-2.7,2.7c-0.9,0.9-2.4,0.9-3.3,0l-9.8-9.8 c-0.4-0.4-0.7-1-0.7-1.7v-1.6c-3.5,2.8-8,4.4-12.5,4.3c-3.6,0-7.1-0.9-10.2-2.7c-3.1-1.8-5.6-4.3-7.4-7.4 c-1.8-3.1-2.8-6.6-2.7-10.2c0-3.6,0.9-7.1,2.7-10.2c1.8-3.1,4.3-5.6,7.4-7.4c3.1-1.8,6.6-2.8,10.2-2.7c3.6,0,7.1,0.9,10.2,2.7 c3.1,1.8,5.6,4.3,7.4,7.4c1.8,3.1,2.8,6.6,2.7,10.2c0.1,4.5-1.5,9-4.3,12.5h1.6c0.6,0,1.2,0.2,1.7,0.7L69.5,61.3z M40.5,50.8 c2.2,0,4.4-0.6,6.3-1.7c1.9-1.1,3.5-2.6,4.5-4.5c1.1-1.9,1.7-4.1,1.7-6.3c0-2.2-0.6-4.4-1.7-6.3c-1.1-1.9-2.6-3.5-4.5-4.5 c-3.9-2.2-8.7-2.2-12.6,0c-1.9,1.1-3.5,2.6-4.5,4.5c-1.1,1.9-1.7,4.1-1.7,6.3c0,2.2,0.6,4.4,1.7,6.3c1.1,1.9,2.6,3.5,4.5,4.5 C36.1,50.3,38.3,50.8,40.5,50.8L40.5,50.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearchNoResults);
export default __webpack_public_path__ + "static/media/global_search_no_results.f4022e11f82d9c8421e484c55de576c3.svg";
export { ForwardRef as ReactComponent };